import { IWhatsappServiceProvider } from "../../contexts/AuthProvider";
import { ISendGenericWhatsAppTemplateRequest } from "./sendGenericWhatsAppTemplate.service";

export type IWAServiceProvider = Exclude<IWhatsappServiceProvider, null>;

export type IShareViaWhatsAppModule =
  | "FOOD_MENU"
  | "QUOTATION"
  | "PAYMENT_REMINDER";

export const SHARE_VIA_WHATSAPP_MODULE_MESSAGES: Record<
  IShareViaWhatsAppModule,
  { success: string; error: string; tooltip: string }
> = {
  FOOD_MENU: {
    success: "Food menu sent successfully via WhatsApp",
    error: "Failed to send food menu via WhatsApp",
    tooltip: "Share food menu via WhatsApp",
  },
  QUOTATION: {
    success: "Quotation sent successfully via WhatsApp",
    error: "Failed to send quotation via WhatsApp",
    tooltip: "Share quotation via WhatsApp",
  },
  PAYMENT_REMINDER: {
    success: "Payment reminder sent successfully via WhatsApp",
    error: "Failed to send payment reminder via WhatsApp",
    tooltip: "Send payment reminder via WhatsApp",
  },
};

export interface IShareViaWhatsAppButtonProps {
  /** The full request payload to send — component handles the API call internally */
  request: ISendGenericWhatsAppTemplateRequest | null | undefined;
  /** Module context — drives default success/error/tooltip messages */
  module?: IShareViaWhatsAppModule;
  /** "icon" = icon-only button (default), "button" = full button with label */
  type?: "icon" | "button";
  size?: "small" | "medium" | "large";
  disabled?: boolean;
  tooltip?: string;
}

export interface IChooseWhatsAppDIalogProps {
  open: boolean;
  onClose: () => void;
  onSelect: (provider: IWAServiceProvider) => void;
  providers: string[];
}